import React from 'react';
import FontAwesome from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  childVisible,
  Visible,
} from 'javascripts/portfolio/components/visible';
const Overlay = childVisible(OverlayTrigger);

export function socialIcon(profile) {
  const socialIconByType = {
    Facebook: 'fa-facebook',
    Twitter: 'fa-twitter',
    Linkedin: 'fa-linkedin',
    Flickr: 'fa-flickr',
    Google: 'fa-google-plus',
    Instagram: 'fa-instagram',
    Skype: 'fa-skype',
    Tumblr: 'fa-tumblr',
    WordPress: 'fa-wordpress',
  };
  const socialIconByHost = {
    'facebook.com': 'fa-facebook',
    'twitter.com': 'fa-twitter',
    'linkedin.com': 'fa-linkedin',
    'flickr.com': 'fa-flickr',
    'plus.google.com': 'fa-google-plus',
    'instagram.com': 'fa-instagram',
    'skype.com': 'fa-skype',
    'tumblr.com': 'fa-tumblr',
    'wordpress.com': 'fa-wordpress',
  };
  const socialIconByProtocol = {
    'skype:': 'fa-skype',
  };

  const hosts = Object.keys(socialIconByHost).map((host) =>
    host.replace('.', '\\.'),
  );

  const regex = new RegExp(`(${hosts.join('|')})`);

  const link = new URL(profile.link);

  const linkHostMatch = link.host.match(regex);

  let output =
    socialIconByType[profile.name] ||
    socialIconByProtocol[link.protocol] ||
    null;

  if (linkHostMatch && linkHostMatch[0]) {
    output = socialIconByHost[linkHostMatch[0]];
  }

  return output || null;
}

const SocialLink = ({ profile }) => {
  const socialIconName = socialIcon(profile);
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line eqeqeq
  const academiaIcon = profile.name == 'Academia.edu';

  return (
    <Overlay
      placement="right"
      modes={(m) => m > 0}
      overlay={
        <Tooltip id="socialLinkTooltip">
          You are in preview mode. Once you register your website, these links
          will work!
        </Tooltip>
      }
    >
      <div className="social-link">
        {!academiaIcon && (
          <FontAwesome
            name={socialIconName ? socialIconName.replace('fa-', '') : 'link'}
            fixedWidth
          />
        )}
        {academiaIcon && (
          <img src={$image_url('academia-logo-redesign-2015-A.svg')} />
        )}
        <Visible modes={(m) => m > 0}>
          <span>{profile.name}</span>
        </Visible>
        <Visible modes={0}>
          <a href={profile.link} target="_blank" rel="noopener noreferrer">
            {profile.name}
          </a>
        </Visible>
      </div>
    </Overlay>
  );
};

export default SocialLink;
